import {
    REQUEST_RARE_DISEASE_TWEETS,
    RESPONSE_RARE_DISEASE_TWEETS,
    FAILURE_RARE_DISEASE_TWEETS,
    REQUEST_RARE_DISEASE_MORE_TWEETS,
    RESPONSE_RARE_DISEASE_MORE_TWEETS,
  } from "../../actions/types";
  
  const initialState = {
    isFetching: false,
    isMoreLoading: false,
    results:[],
    error: false,
    isInitalScreen: true,
    size: 20,
    from: 0,
    hashtag: "",
    sort: "",
    isMoreEmpty: false,
    handleBio: undefined
  };

  const setMoreFetching = (state, action) => {
    let from = action.payload.from;
    return {
      ...state,
      isMoreLoading: true,
      size: 20,
      from: from
    };
  };


  const setFetching = (state, action) => {
    let hashtag = action.payload.hashtag;
    let sort = action.payload.sort;
    return {
      ...state,
      isFetching: true,
      isInitalScreen: false,
      hashtag: hashtag,
      sort: sort,
      size: 20,
      from: 0,
      isMoreEmpty: false
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: true,
      results:[]
    };
  };
  
  const setResults = (state, action) => {
    let results = action.payload.results || [];
    let total = action.payload.total;
    let handleBio = action.payload.handleBio;
    return {
      ...state,
      handleBio: handleBio,
      isFetching: false,
      error: false,
      results,
      total
    };
  };

  const setMoreResults = (state, action) => {
    let results = action.payload.results || [];
    let isMoreEmpty = results.length == 0;
    let oldResults = [...state.results, ...results];
    return {

      ...state,
      isMoreLoading: false,
      error: false,
      results: oldResults,
      isMoreEmpty,
    };
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_RARE_DISEASE_TWEETS:
        return setFetching(state, action);
        break;
  
      case RESPONSE_RARE_DISEASE_TWEETS:
        return setResults(state, action);
  
      case FAILURE_RARE_DISEASE_TWEETS:
        return setFailure(state, action);
  
      case RESPONSE_RARE_DISEASE_MORE_TWEETS:
          return setMoreResults(state, action);
          break;
    
      case REQUEST_RARE_DISEASE_MORE_TWEETS:
          return setMoreFetching(state, action);
    
      default:
        return state;
        break;
    }
  };
  